import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.user.school_id) {
      localStorage.setItem("activeSchool", r.data.user.school_id);
    }
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("activeSchool");
    localStorage.removeItem("activeSchoolName");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function getActiveSchool() {
  return localStorage.getItem("activeSchool");
}

export function setActiveSchool(id, name) {
  localStorage.setItem("activeSchool", id);
  localStorage.setItem("activeSchoolName", name || "");
}

export function homeForRole(user) {
  if (!user) return "/login";
  if (user.role === "superadmin") return "/colegios";
  if (user.role === "padre") return "/portal";
  if (user.role === "maestro") return "/maestro";
  return "/dashboard";
}
